import axios from "axios"

export async function getPoolsByTwoCoinTypes(coinTypes: string[]) {
  const res = await axios.post(`https://api-sui.cetus.zone/v3/sui/clmm/stats_pools`, {
    coinTypes
  })
  return res
}

